exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filterbar .filter_by[data-v-hardwarefilter] ul li ul li .md-checkbox .md-checkbox-label{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 170px;\n}\n", ""]);

// exports
